/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  EventNotificationConfigInput,
  EventNotificationConfig,
} from '..';
import {
  serializeEventNotificationConfigInput,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface ManageAzzurroEventInput {
  plantId: string;
  input: EventNotificationConfigInput;
}
const build = (_query: DocumentNode, input: ManageAzzurroEventInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.plantId !== undefined ? `$plantId: String = ${JSON.stringify(input.plantId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.input !== undefined ? `$input: EventNotificationConfigInput = ${serializeEventNotificationConfigInput(input.input)}` : '' ) + `){
    manageAzzurroEvent(
      ${ input.plantId !== undefined ? 'plantId: $plantId,' : '' } 
      ${ input.input !== undefined ? 'input: $input,' : '' }
    ){
      ...eventnotificationconfig
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class ManageAzzurroEventMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment eventnotificationconfig on EventNotificationConfig { ... }
   */
  async execute(_query: DocumentNode, input: ManageAzzurroEventInput): Promise<apollo.FetchResult< { manageAzzurroEvent: Partial<EventNotificationConfig> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ manageAzzurroEvent: Partial<EventNotificationConfig> }>({ mutation: build(_query, input) });
  }
}
